import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";
import {
    getdiscrepancyCollection,
    DiscrepancyCollectionParam,
    DiscrepancyCollectionResult,
} from "@tKgpco/Services/DiscrepancyService";
import { getRMACollection, RMACollectionParam, RMACollectionResult } from "@tKgpco/Services/RMAService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<RMACollectionParam, RMACollectionResult>;

export const PopulateApiParameter: HandlerType = props => {
    props.dispatch({
        type: "Custom/RMA/BeginLoadRMACollection",
        params: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getRMACollection(props.parameter);
};

export const DispatchCompleteRMACollection: HandlerType = props => {
    props.dispatch({
        type: "Custom/RMA/CompleteLoadRMACollection",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteRMACollection];

export const loadRMACollection = createHandlerChainRunner(chain, "loadRMACollection");
export default loadRMACollection;
